export enum PrivacyOptionsRequirementStatus {
  /**
   * Privacy options entry point is not required.
   */
  NOT_REQUIRED = 'NOT_REQUIRED',

  /**
   * Privacy options entry point is required.
   */
  REQUIRED = 'REQUIRED',

  /**
   * Privacy options requirement status is unknown.
   */
  UNKNOWN = 'UNKNOWN',
}
